
export async function DeleteJutgeEnviament(id: string) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}:8061/jutge/enviament/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    return response;
}
